export default __webpack_public_path__ + "static/media/NotoSans-Regular.09ae578f.woff";